import { Component, OnInit, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticationService } from '../../../../core/services/AuthServices/auth.service';
import { environment } from '../../../../../environments/environment';
import {Subscription} from "rxjs";
import {Beneficiary} from "../../../../Modules/Shared/Models/Beneficiary";
import {HttpErrorResponse} from "@angular/common/http";
import {CustomSwal} from "../../../../Modules/Shared/Services/CustomSwal";
import {AuthServerResponseObject} from "../../Models/AuthServerResponseObject";
import {
  indexNoValidator,
  phoneNumberResetPasswordCompare,
  stringCompareValidator
} from "../../../../Modules/Shared/UtilityClass/CustomValidators";

@Component({
  selector: 'app-passwordreset',
  templateUrl: './passwordreset.component.html',
  styleUrls: ['./passwordreset.component.scss']
})

/**
 * Reset-password component
 */
export class PasswordresetComponent implements OnInit, AfterViewInit {
  private subscriptions: Subscription[] = [];
  beneficiary_details: Beneficiary = null;
  resetForm: UntypedFormGroup;
  submitted = false;
  error = '';
  success = '';
  loading_get_index_account: boolean = false;
  loadingChangePassword: boolean;
  has_benef_reg_phone: boolean = false;

  // set the current year
  year: number = new Date().getFullYear();

  // tslint:disable-next-line: max-line-length
  constructor(private formBuilder: UntypedFormBuilder,
              private route: ActivatedRoute,
              private router: Router,
              private authenticationService: AuthenticationService) { }

  ngOnInit() {

    this.resetForm = this.formBuilder.group({
      index_no: ['', [Validators.required, indexNoValidator()]],
      last_name: ['', [Validators.required]],
      phone_no: ['', []],
      email: ['', []],
      password: ['', [Validators.required]],
    });

    // subscribe on index-number on form change
    this.resetForm.get('index_no').valueChanges.subscribe(index_no => {
      this.beneficiary_details = null;
      // check if the index-number is complete S0485.0013.2019
      // check index_no is not null
      if(index_no != null) {
        // check if length is 15-chars for the correct index-no
        if(index_no.length == 15) {
          // correct index-no length
          this.loading_get_index_account =  true;
          // get index-no account-details
          this.getIndexNumberPasswordResetDetails(index_no);
        }
        else {
          this.loading_get_index_account = false;
        }
      }
      else {
        this.loading_get_index_account = false;
      }
    });
  }

  ngAfterViewInit() {
  }

  // convenience getter for easy access to form fields
  get f() { return this.resetForm?.controls; }

  /**
   * On submit form
   */
  onSubmit() {
    this.success = '';
    this.submitted = true;

    this.loadingChangePassword = true;
    const body = {
      'index_no': this.resetForm?.get('index_no').value,
      'password': this.resetForm?.get('password').value
    }
    this.subscriptions.push(this.authenticationService?.resetBenefPassword(body).subscribe(
      {
        next: (response: AuthServerResponseObject) => {
          this.loadingChangePassword = false;
          CustomSwal.toastSuccess(`Successfully Changed Password`);
        },
        error: (errors: HttpErrorResponse) => {
          this.loadingChangePassword = false;
          CustomSwal.toastFailed(errors?.error?.detail);
        }
      }
    ));
  }

  getIndexNumberPasswordResetDetails(index_no: string) {
    console.log(index_no);
    this.beneficiary_details = null;
    this.loading_get_index_account = true;
    this.subscriptions.push(this.authenticationService?.getResetPasswordBenefDetails(index_no).subscribe(
      {
        next: (response: AuthServerResponseObject) => {
          this.beneficiary_details = response?.body;
          this.loading_get_index_account = false;
          console.log(this.beneficiary_details);
          // add validator for the last name
          this.resetForm?.controls['last_name'].addValidators([stringCompareValidator(`${this.beneficiary_details?.last_name}`)]);
          // check if benef_reg_phone is present
          if(this.beneficiary_details?.benef_reg_phone != null && this.beneficiary_details?.benef_reg_phone !== '') {
            //  add validator for phone-no comparison
            this.has_benef_reg_phone = true;
            this.resetForm?.controls['phone_no'].addValidators([phoneNumberResetPasswordCompare(`${this.beneficiary_details?.benef_reg_phone}`, `${this.beneficiary_details?.mobile}`)]);
            this.resetForm?.controls['phone_no'].addValidators([Validators.required]);
          }
          else {
            // add validators to compare email-address
            this.resetForm?.controls['email'].addValidators([stringCompareValidator(this.beneficiary_details?.email)])
            this.resetForm?.controls['email'].addValidators([Validators.required]);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.loading_get_index_account = false;
          CustomSwal.toastFailed(error?.error?.detail);
        }
      }
    ));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe())
  }
}
